<ng-container [formGroup]="form" *ngIf="form">
  <common-empty-input
    [label]="label"
    [labelWidth]="labelWidth"
    [control]="control"
    [required]="required"
  >
    <ng-container input>
      <input
        class="{{ inputStyleClass }}"
        type="text"
        [formControlName]="property"
      />
    </ng-container>
  </common-empty-input>
</ng-container>
